// Kampanya tekrar kullanılana kadar false bırakılır. Yeni bir mağaza için
// PET_CAMPAIGN_POI_ID güncellenip true yapılması yeterlidir.
export const PET_CAMPAIGN_ENABLED = false;
export const PET_CAMPAIGN_POI_ID = "15781135918775571959";
export const PET_CAMPAIGN_CODE = "500500";
export const PET_CAMPAIGN_TITLE =
  "Easy Point’ten Pet Arabası Kiralayana, PAWCO’da 500 TL İndirim Kazanma Fırsatı! 🐾";
export const PET_CAMPAIGN_DESCRIPTION =
  "05.09.2026 – 30.09.2026 tarihleri arasında Easy Point Watergarden’dan pet arabası kirala, PAWCO pet kuaför hizmetinde 500 TL indirim kazan. Kazandığın indirimi 31.10.2026 tarihine kadar kullanabilirsin.";
export const PET_CAMPAIGN_VALIDITY = "05.09.2026 – 30.09.2026";
export const PET_CAMPAIGN_BANNER_LABEL = "Pawco indiriminiz var";
export const PET_CAMPAIGN_MODAL_TITLE = "500 TL PAWCO İndiriminiz Hazır! 🎉";
export const PET_CAMPAIGN_MODAL_VALIDITY =
  "Kodunuzu 31.10.2026 tarihine kadar PAWCO Watergarden’da pet kuaför hizmetinde kullanabilirsiniz.";
export const PET_CAMPAIGN_MODAL_FOOTER =
  "Kodunuza dilediğiniz zaman ana sayfadan ulaşabilirsiniz.";

export const isPetCampaignPoi = (poiID) =>
  PET_CAMPAIGN_ENABLED && Boolean(PET_CAMPAIGN_POI_ID) && Boolean(poiID) && poiID === PET_CAMPAIGN_POI_ID;

export const isPetCampaignService = (selectedService) =>
  selectedService === "hayvan" || selectedService === "pet-car";
